import {
  Component,
  EventEmitter,
  Output,
  Input,
  OnInit,
  OnDestroy
} from '@angular/core';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { Flavor } from '../../providers/flavor/flavor';
import { FlavorProviderSearch } from '../../providers/flavor/flavor-search';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IonRange, IonGrid, IonRow, IonCol, IonItem } from '@ionic/angular';

/**
 * Generated class for the FlavorSliderSearchComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'flavor-slider-search',
  templateUrl: 'flavor-slider-search.html',
  styleUrls: ['./flavor-slider.scss'],
  standalone: false,
  imports: [
     IonicModule,
  //   CommonModule,
  //   FormsModule,
  //   TranslateModule
  ]
})
export class FlavorSliderSearchComponent implements OnInit, OnDestroy {

  @Output() notify: EventEmitter<any> = new EventEmitter<any>();

  private setShouldupdateSubscription: any;
  private resetSliderSubscription: any;
  private updateSlidersSubscription: any;
  private removeAllSearchSubscription: any;

  flavor: Flavor;

  shouldUpdate: boolean = false;
  shouldUpdateCount: number = 0;

  constructor(private events: AppEventService, private bhutil: BhutilProvider, private flavorProvider: FlavorProviderSearch) {
    this.initFlavor();
  }

  private initFlavor() {
    this.flavor = this.flavorProvider.getFlavor();
  }

  subscribeEvents() {

    this.setShouldupdateSubscription = (shouldUpdate: boolean) => {
      console.log(this);
      console.log("[flavor-slider-search] setting shouldUpdate value to " + shouldUpdate);
      this.shouldUpdate = shouldUpdate;
      this.shouldUpdateCount = 0;
    };
    this.events.subscribe("set:shouldupdate", this.setShouldupdateSubscription);

    this.resetSliderSubscription = (key: string) => {
      console.log("[flavor-slider-search] SUB reset:slider - resetting slider value for key " + key);

      this.flavor.reset(key);
    };
    this.events.subscribe("reset:slider", this.resetSliderSubscription);

    this.updateSlidersSubscription = (values: any) => {

      console.log("[flavor-slider-search] SUB update:sliders => with value shouldUpdate " + values.update);
      console.dir(values);

      this.shouldUpdate = values.update;
      this.shouldUpdateCount = 0;

      this.flavor.setIntValue("sweet", values.sweet);
      this.flavor.setIntValue("sour", values.sour);
      this.flavor.setIntValue("bitter", values.bitter);
      this.flavor.setIntValue("hoppy", values.hoppy);
      this.flavor.setIntValue("fruity", values.fruity);
      this.flavor.setIntValue("malty", values.malty);

    };
    this.events.subscribe("update:sliders", this.updateSlidersSubscription);

    this.removeAllSearchSubscription = (value: any) => {

      //debugger;

      //reset all sliders!

      this.shouldUpdate = false;
      this.shouldUpdateCount = 0;

      this.flavor.setIntValue("sweet", -1);
      this.flavor.setIntValue("sour", -1);
      this.flavor.setIntValue("bitter", -1);
      this.flavor.setIntValue("hoppy", -1);
      this.flavor.setIntValue("fruity", -1);
      this.flavor.setIntValue("malty", -1);

    };
    this.events.subscribe("remove:allsearch", this.removeAllSearchSubscription);
  }

  ngOnInit() {
    console.log("[flavor-slider-search] - ngOnInit");

    this.initFlavor();

    this.subscribeEvents();

    // force update of search characteristics if at least one is not -1
    // parameter callServer steers if the search request is sent to the backend
    let callServerMalty: Boolean = (this.flavor.maltyIntValue.valueOf() >= 0);
    let callServerFruity: Boolean = !callServerMalty && (this.flavor.fruityIntValue.valueOf() >= 0);
    let callServerHoppy: Boolean = !callServerFruity && !callServerMalty && (this.flavor.hoppyIntValue.valueOf() >= 0);
    let callServerBitter: Boolean = !callServerHoppy && !callServerFruity && !callServerMalty && (this.flavor.bitterIntValue.valueOf() >= 0);
    let callServerSour: Boolean = !callServerBitter && !callServerHoppy && !callServerFruity && !callServerMalty && (this.flavor.sourIntValue.valueOf() >= 0);
    let callServerSweet: Boolean = !callServerSour && !callServerBitter && !callServerHoppy && !callServerFruity && !callServerMalty && (this.flavor.sweetIntValue.valueOf() >= 0);

    if (this.flavor.sweetIntValue.valueOf() >= 0) {
      this.onFlavorChange("sweet", { detail: { value: this.flavor.sweetIntValue }}, callServerSweet);
    }
    if (this.flavor.sourIntValue.valueOf() >= 0) {
      this.onFlavorChange("sour", { detail: { value: this.flavor.sourIntValue }}, callServerSour);
    }
    if (this.flavor.bitterIntValue.valueOf() >= 0) {
      this.onFlavorChange("bitter", { detail: { value: this.flavor.bitterIntValue }}, callServerBitter);
    }
    if (this.flavor.hoppyIntValue.valueOf() >= 0) {
      this.onFlavorChange("hoppy", { detail: { value: this.flavor.hoppyIntValue }}, callServerHoppy);
    }
    if (this.flavor.fruityIntValue.valueOf() >= 0) {
      this.onFlavorChange("fruity", { detail: { value: this.flavor.fruityIntValue }}, callServerFruity);
    }
    if (this.flavor.maltyIntValue.valueOf() >= 0) {
      this.onFlavorChange("malty", { detail: { value: this.flavor.maltyIntValue }}, callServerMalty);
    }
  }

  ngOnDestroy() {
    console.log("[flavor-slider-search] - ngOnDestroy");
    this.events.unsubscribe("set:shouldupdate", this.setShouldupdateSubscription);
    this.events.unsubscribe("reset:slider", this.resetSliderSubscription);
    this.events.unsubscribe("update:sliders", this.updateSlidersSubscription);
    this.events.unsubscribe("remove:allsearch", this.removeAllSearchSubscription);
  }

  onSweetChange(event: any) {
    this.onFlavorChange("sweet", event, true);
  }

  onSourChange(event: any) {
    this.onFlavorChange("sour", event, true);
  }

  onBitterChange(event: any) {
    this.onFlavorChange("bitter", event, true);
  }

  onHoppyChange(event: any) {
    this.onFlavorChange("hoppy", event, true);
  }

  onFruityChange(event: any) {
    this.onFlavorChange("fruity", event, true);
  }

  onMaltyChange(event: any) {
    this.onFlavorChange("malty", event, true);
  }

  onFlavorChange(flavorName: string, event: any, callServer: Boolean) {
    let eventFlavorIntValue: Number = event.detail.value;
    console.log("[flavor-slider-search] " + flavorName + " value is now " + this.bhutil.stringify(eventFlavorIntValue));
    this.flavor.setIntValue(flavorName, eventFlavorIntValue);

    let e: any = {
      value: eventFlavorIntValue,
      type: flavorName,
      callServer: callServer
    }

    console.log("[flavor-slider-search] on " + flavorName);
    this.notify.emit(e);
  }
}
